export default {
  resourceManagers: {
    searchPlaceholder: 'Search',
    all: 'All',
    back: 'Back',
    searchResults: 'Search Results',
    audioUploader: {
      localUpload: 'Upload',
      tips: 'Browse all assets',
    },
    dialog: {
      tips: 'Only show assets that meet the current formatting requirements',
    },
    apply: 'Apply',
    clearAll: 'Clear all',
    noDataTip: 'No Data',
  },
}
